import { Fade, Grid, MenuItem, Typography } from '@mui/material';

import { useAppSelector } from '@/redux/hooks';
import { TitleEntityV2 } from '@/redux/slices/titleV2Slice.types';
import { selectChildrenLoadingStatusByTitleId } from '@/redux/selectors/titleV2Selectors';
import { LoadingStatuses } from '@/constants/constants';
import DropdownSelect from '@/components/_common/Form/DropdownSelect';

type SelectedTitleV2 = {
  options: TitleEntityV2[];
  value: TitleEntityV2 | null;
};

type SelectedTitleProps = {
  index: number;
  title: SelectedTitleV2;
  onTitleChange: (title: TitleEntityV2, index: number) => void;
};

const SelectedTitle = ({ index, title, onTitleChange }: SelectedTitleProps) => {
  const options = title.options;
  const entityType = title.value?.entity_type || options[0]?.entity_type;
  const selectedTitle = title.value || options[index];
  const isLoading = useAppSelector((state) => selectChildrenLoadingStatusByTitleId(state, selectedTitle?.id)) === LoadingStatuses.pending;

  const getPrepend = (child: TitleEntityV2) => {
    if (child.entity_type === 'episode') {
      return (
        <Typography variant="caption" sx={{ mr: 0.75 }}>
          E{child.sequence_order}:
        </Typography>
      );
    }
  };

  const getAppend = (child: TitleEntityV2) => {
    if (child.entity_type === 'version') {
      return (
        <Typography variant="caption" sx={{ ml: 0.75 }}>
          [ID: {child.external_id}]
        </Typography>
      );
    }
    if (child.entity_type === 'ova') {
      return (
        <Typography variant="caption" sx={{ ml: 0.75 }}>
          [OVA]
        </Typography>
      );
    }
  };

  return (
    <Fade in timeout={(index + 1) * 300}>
      <Grid item key={index} xs={12} lg={6} xl={3} mb={3}>
        <DropdownSelect
          fullWidth
          loading={isLoading}
          label={!isLoading && !options.length ? `No Options Available` : `Select ${entityType}`}
          value={title.value || ''}
          disabled={!options.length}
          onChange={(val) => onTitleChange(val, index)}
        >
          {options.map((child) => (
            <MenuItem key={child.id} value={child as any}>
              {getPrepend(child)}
              {child.name}
              {getAppend(child)}
            </MenuItem>
          ))}
        </DropdownSelect>
      </Grid>
    </Fade>
  );
};

export default SelectedTitle;
